/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns item just added
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  // FormData support
  var formData = form instanceof FormData
    ? { id: form.get('id'), quantity: form.get('quantity'), properties:{_is_online:'true'} }
    : jQuery(form).serialize();

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(form, XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(form, jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, form, jqxhr, text]);
    }
  };
  return jQuery.ajax(params);
};

/*============================================================================
  POST to cart/add.js with multiple items returns all the items added
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addMultipleToCart = function(items, callback, errorCallback) {
  var $body = $(document.body);
  var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: { items: items, properties: {'_is_online': 'true'}},
      dataType: 'json',
      success: function(data) {
        if ((typeof callback) === 'function') {
          callback(data);
        }
        $body.trigger('afterAddMultipleItems.ajaxCart', data);
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest);
        }
        else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
      }
    };
  return jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }

    $(document.body).trigger('afterGetCart.ajaxCart', cart);
    window.dispatchEvent(new CustomEvent('afterGetCart', {detail: {cart: cart}}));

  }).done(function() {
    ajaxCart.isUpdating = false;
  });
};

// POST to cart/change.js using line number and returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {

  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line + '&properties[_is_online]=true',
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  return jQuery.ajax(params);
};

// POST to cart/change.js using variantId returns the cart in JSON
ShopifyAPI.adjustItem = function(variantId, quantity, callback) {

  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&id=' + variantId + '&properties[_is_online]=true',
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeChangeItem.ajaxCart', [variantId, quantity]);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
        else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [variantId, quantity, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
    };
  return jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartItemsContainer, $cartCheckoutContainer;

  // Private functions
  var updateCartCount, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback,
      loadCartToUpdateCartCount, buildCart, cartCallback, adjustCart, adjustCartCallback, qtySelectors, validateQty, updateRecommendation;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function () {

    // Default settings
    settings = {
      formSelector: '.js-form-add-to-cart',
      cartItemsContainer: '#cart-items-template-renderer',
      cartCheckoutContainer: '#cart-checkout-template-renderer',
      addToCartSelector: '.js-add-to-cart:not(.needVariant, .js-add-to-progress)',
      cartCountSelector: '#cart-opener',
      moneyFormat: window.Shopify.moneyFormat,
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartItemsContainer     = $(settings.cartItemsContainer);
    $cartCheckoutContainer = $(settings.cartCheckoutContainer);
    $addToCart         = $(settings.formSelector).find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    this.isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();


  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  loadCartToUpdateCartCount = function () {
    ShopifyAPI.getCart(updateCartCount);
  }

  updateCartCount = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.find('.cart-item').text(cart.item_count);
      $cartCountSelector.find('.cart-empty').toggleClass('is-hidden', cart.item_count > 0);
      $cartCountSelector.find('.cart-item-parent').toggleClass('is-hidden', cart.item_count < 1);
    }
  };

  formOverride = function () {
    $body.on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
    });

    $body.on('click', settings.addToCartSelector, function(evt) {
      var $el = $(this),
          $formContainer = $el.closest(settings.formSelector);

      // Submit closest form
      evt.stopPropagation();
      $formContainer.submit();

      // Add class to be styled if desired
      $el.removeClass('is-added');

      // Remove any previous quantity errors
      $formContainer.siblings('.qty-error').remove();

      ShopifyAPI.addItemFromForm($formContainer, itemAddedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product, form) {
    jQuery(form).find(settings.addToCartSelector).removeClass('loading').addClass('is-added');
    $body.trigger('cart:item-added');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (form, XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    jQuery(form).find(settings.addToCartSelector).removeClass('loading is-added');

    if (!!data.message) {
      if (data.status == 422) {
        jQuery(form).after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCartCount(cart);
    buildCart(cart);

    // Upate Algolia Recommendation
    updateRecommendation(cart);
  };

  buildCart = function (cart) {
    // Start with a fresh cart div
    $cartItemsContainer.empty();
    $cartCheckoutContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartItemsContainer
        .append('<div class="gutter-top--half"><p class="is-italic text--light">' + "Your cart is currently empty." + '</p></div>');
      cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source),
        cartCheckoutSource = $("#CartCheckoutTemplate").html(),
        cartCheckoutTemplate = Handlebars.compile(cartCheckoutSource);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      var isFreeProduct = cartItem.line_price == 0 ? 'js-ajaxcart-is-free' : '';
      var brand = cartItem.vendor === "notforsale" ? 'culture-kings' : Shopify.handleize(cartItem.vendor);
      var vendorLogoLink = "https://culture-kings-static.imgix.net/images/logos-left/brand-" + brand + ".jpg" + "?h=100&auto=compress,format";
      var vendorLink = "/collections/" + brand;

      const getPercent = title => parseInt(title.match(/(\d+)%/)?.[1] || 0, 10);
      const topDiscount = cartItem.discounts?.length
        ? cartItem.discounts.reduce((best, current) => {
          return getPercent(current.title) > getPercent(best.title) ? current : best;
        })
        : null;
      const hasStaffDiscount = topDiscount?.title?.includes('STAFF');

      const orginalPrice = hasStaffDiscount ? cartItem.final_line_price / (100 - getPercent(topDiscount.title)) * 100 : cartItem.original_line_price;



      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        id: cartItem.product_id,
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        isFreeProduct: isFreeProduct,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(orginalPrice, settings.moneyFormat),
        discounts: topDiscount ? [topDiscount] : [],
        discountsApplied: cartItem.line_price === orginalPrice ? false : true,
        brandLogo: vendorLogoLink,
        brandLink: vendorLink,
        giftCard: cartItem.gift_card,
      };

      items.push(item);
    });

    var afterPayPrice = cart.total_price / 4,
        laybuyPrice = cart.total_price / 6

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      afterPayPrice: (Shopify.formatMoney(afterPayPrice, settings.moneyFormat)),
      laybuyPrice: (Shopify.formatMoney(laybuyPrice, settings.moneyFormat)),
      isCartTotalOver2000: cart.total_price >= 200000,
      customsTax: false,
      afterpayEligible: items.every((item) => item.properties && item.properties._afterpay_eligible && !item.giftCard),
      isAfterpayOnly: items.some((item) => item.properties && item.properties._is_afterpay_only)
    }

    switch(Shopify.shop) {
      case "culture-kings-nz.myshopify.com":
        data.customsTax = cart.total_price >= 20000 ? Shopify.formatMoney(cart.total_price * 0.15, settings.moneyFormat) : false
        break;
    }

    $cartItemsContainer.append(template(data));
    $('#cart-nudge-and-free-gifts-section').removeClass('hide');
    $cartCheckoutContainer.append(cartCheckoutTemplate(data));

    theme.afterpayMarketingModal(); // init afterpay/laybuy popup
    cartCallback(cart);
  };

  cartCallback = function(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    // this is to remove bundle id in cart, so user will only see "💰 Bundle Promotion"
    var bundleElement = document.getElementsByClassName('cart-product-promo-tag')
    for (var i = 0; i < bundleElement.length; i ++){
      if (bundleElement[i].innerHTML.includes("Bundle")) {
        bundleElement[i].innerHTML = "💰 Bundle Promotion"
      }
    }

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    $addToCart.addClass('is-added');
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.cart-adjust', function() {
      if (ajaxCart.isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.cart-input'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('cart-button-plus')) {
        qty += 1;
      } else if ($el.hasClass('cart-button-remove')) {
        qty = 0;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }

    });

    // Update quantity based on input on change
    $body.on('change', '.cart-input', function() {
      if (ajaxCart.isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (ajaxCart.isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.cart-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      ajaxCart.isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCartCount(cart);
    updateRecommendation(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  updateRecommendation = function (cart) {
    var $cartRecommendProducts = $('#cart-recommend-products');
    if(cart.items && cart.items.length > 0) {
      var props = $cartRecommendProducts.data('props') || {};
      props.productIds = cart.items.reduce(function (acc, item){
        if(item.properties && item.properties['_FREE_NFS_GIFT']) return acc;
        acc.push(item.product_id);
        return acc;
      }, []);
      props.hasDivider = true;
      $cartRecommendProducts.attr('data-props', JSON.stringify(props));
      $cartRecommendProducts.attr('data-component', 'RecommendedProducts');
      document.dispatchEvent(new Event('renderRecommendedProducts'));
    } else if ($('#cart-recommend-products').children().length > 0){
      $('#cart-recommend-products').empty();
    }
  }

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element

    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    loadCartToUpdateCartCount: loadCartToUpdateCartCount
  };

  return module;

}(ajaxCart || {}, jQuery));
